function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _classCallCheck(a, n) {
    if (!_instanceof(a, n)) throw new TypeError("Cannot call a class as a function");
}
export { _classCallCheck as default };
